// import BillOfSaleLayout from "@layouts/billofsale/BillOfSaleLayout";
import BillOfSaleDetailsInfo from "@modules/bill-of-sale/components/BillOfSaleDetailsInfo";
import BillOfSaleForm from "@modules/bill-of-sale/components/BillOfSaleForm";
import BillOfSaleIntroInfo from "@modules/bill-of-sale/components/BillOfSaleIntroInfo";
import useBillOfSaleFormStepsReducer from "@modules/bill-of-sale/hooks/useBillOfSaleFormStepsReducer";
import { GetStaticProps, GetStaticPropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import PublicLayout from "@layouts/public/components/PublicLayout";

const CreatebillOfSale = () => {
  const billOfSaleReducer = useBillOfSaleFormStepsReducer();
  const [billOfSaleState] = billOfSaleReducer;

  const { t } = useTranslation(["billOfSalePage"]);

  return (
    <PublicLayout>
      <Head>
        <title>{t("billOfSalePage:bill_of_sale_page_title")}</title>
      </Head>
      <div className="flex flex-col-reverse lg:flex-row bg-white tall:min-h-screen">
        {/** Left Pane */}
        <div className="w-full lg:w-[70%] bg-white flex-grow">
          <BillOfSaleForm billOfSaleReducer={billOfSaleReducer} />
        </div>

        {/** Right Pane */}
        <div className="bg-gray-25 lg:w-[30%] flex-grow hidden lg:block ">
          <div className="sticky top-12">
            {billOfSaleState.isVinDecodeComplete ? (
              <span>
                <BillOfSaleDetailsInfo billOfSaleReducer={billOfSaleReducer} />
              </span>
            ) : (
              <BillOfSaleIntroInfo />
            )}
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

CreatebillOfSale.pageName = "CreatebillOfSale";

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext
) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? "en", [
        "common",
        "common-components",
        "billOfSalePage",
      ])),
    },
    revalidate: 5 * 60, // 5 minutes
  };
};

export default CreatebillOfSale;
